export default "__VITE_ASSET__CNTdR7lh__"